import { defineReportOptions } from '@ks-personal/reporter'
import { SentryCdnAdapter } from '@ks-personal/reporter/sentry-cdn.adapter'

export const setupSentry = () => {
  defineReportOptions({
    reporter: new SentryCdnAdapter({
      enableLogReport: true,
    }),
  })
}
